import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class BillpayService {

  private URL = environment.api + "api/erp/billpay";
	constructor(
		private http: HttpClient
	) { }

	getBills(idClient) {
		return this.http.get(this.URL + "/bills/60/" + idClient);
	}

	getBillsWarehouse(idClient) {
		return this.http.get(this.URL + "/bills-warehouse/60/" + idClient);
	}

	getNCRESByDate(startDate: number, endDate: number, source:any) {
    return this.http.get(this.URL + '/ncre/' + source, {
      params: {
        startDate: startDate,
        endDate: endDate
      }
    })
  }

	setAdvance(request) {
		return this.http.post(this.URL + "/payment", request);
	}

	deleteNcre(billToPayId: any) {
		return this.http.delete(this.URL + '/ncre/' + billToPayId);
	}

	saveRequest(request, banktransferlogid){
		return this.http.post(this.URL + "/save-request/" + banktransferlogid, request);
	}
}
